import React, { Component } from "react";
import General from "./General/General";
import MenuItems from "./Menu/MenuItems";
import { Displays } from "./Displays/Displays";
import Entities from "./Entities/Entities";
import NavigationBarandLogo from "./NavigationBarandLogo/NavigationBarandLogo";
import { Navigate } from "react-router-dom";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Content, Header, PageContainer } from "../Drawer/PageContainer";
import { MsalContext } from "@azure/msal-react";
import { CheckForInternalUser } from "../Helpers/miscellaneous";
import WorkspaceAppModelContext from "../../Context/Workspace/WorkspaceAppModelContext";
import { withTranslation } from "react-i18next";
import ObjectsAndPages from "./Displays/ObjectsAndPages";
import { propogateChangeToRealtimeIframe } from "../Helpers/Runtime/runtime";

class PortalDetail extends Component {

    static contextType = MsalContext;

    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selectedTab,
            portalName: props.portal.portalName,
            redirectToPortal: false,
            tabs: {
                general: true,
                entities: false,
                isInternalUser: false,
                menuItems: false,
                displayConfig: false,
            },
        };
    }

    componentDidMount = async () => {
        let { tabs } = this.state;
        let isInternalUser = CheckForInternalUser(this.props.user.email)
        tabs.menuItems = this.props.project.developerMode && isInternalUser;
        tabs.displayConfig = this.props.project.developerMode && isInternalUser;
        window.addEventListener("message", this.handleMessage);
        this.setState({
            isInternalUser: isInternalUser,
            tabs: tabs,
        });
    };

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }

    handleMessage = (event) => {
        if (event.origin === window.location.origin && typeof event.data === "string") {
            const data = JSON.parse(event.data);
            if (data.type === "GET_CONTEXT_REALTIME_API") {
                propogateChangeToRealtimeIframe(
                    this.props.organization._id,
                    this.props.project._id,
                    "changeContext",
                    {
                        portalId: this.props.portal._id,
                    }
                )
            }
        }
    }

    updatePortal = async (portal) => {
        this.setState({ portalName: portal.portalName });
    }


    render() {
        const { t } = this.props;
        if (this.state.redirect) {
            let url = `/${this.props.organization.orgName}/${this.props.project.name}/Portals/${this.props.portal.portalName}/`;

            if (this.state.selected === 1) {
                url += "General";
            } else if (this.state.selected === 0) {
                url += "Entities";
            } else if (this.state.selected === 2) {
                url += "NavigationBarandLogo";
            } else if (this.state.selected === 3) {
                url += "MenuItems";
            } else {
                url += "Displays";
            }

            this.setState({ redirect: false });

            return <Navigate to={url} />;
        }

        if (this.state.redirectToPortal) {
            let url = `/${this.props.organization.orgName}/${this.props.project.name}/Portals`;
            return <Navigate to={url} />;
        }

        return (
            <PageContainer>
                <div className="ml-3">
                    <Header
                        hideBorder={false}
                        header={this.state.portalName}
                        allowBackButton={true}
                        backButtonText={t("header.buttons.back_to_Portals_label")}
                        backButtonClicked={this.goToPortal}
                    ></Header>
                </div>
                {this.props.portal.portalName && (
                    <Content>
                        <div className="custom-tab h-100">
                            <TabStrip
                                animation={false}
                                className="splitter-tab h-100 ps-1"
                                selected={this.state.selected}
                                onSelect={this.handleSelect}
                            >
                                <TabStripTab title={t("portal_detail_tabs.object_selection")}>
                                    <Entities
                                        useSuspense={false}
                                        organization={this.props.organization}
                                        project={this.props.project}
                                        portal={this.props.portal}
                                    />
                                </TabStripTab>
                                <TabStripTab title={t("portal_detail_tabs.general")}>
                                    <WorkspaceAppModelContext.Consumer>
                                        {
                                            (context) => (
                                                <General
                                                    useSuspense={false}
                                                    organization={this.props.organization}
                                                    project={this.props.project}
                                                    portal={this.props.portal}
                                                    workspaceAppModelContext={context}
                                                    updatePortal={this.updatePortal}
                                                    setSelectedPortal={context.mutators.setSelectedPortal}
                                                />
                                            )
                                        }
                                    </WorkspaceAppModelContext.Consumer>
                                </TabStripTab>
                                <TabStripTab title={t("portal_detail_tabs.navigation_bar_and_logos")}>
                                    <NavigationBarandLogo
                                        useSuspense={false}
                                        organization={this.props.organization}
                                        project={this.props.project}
                                        portal={this.props.portal}
                                    />
                                </TabStripTab>
                                {this.state.tabs.menuItems && (
                                    <TabStripTab title={t("portal_detail_tabs.menu_items")}>
                                        <MenuItems
                                            portalId={this.props.portal._id}
                                            projectId={this.props.project._id}
                                        />
                                    </TabStripTab>
                                )}

                                {/*
                                    <TabStripTab title={t("portal_detail_tabs.pages")}>
                                        <ObjectsAndPages
                                            orgName={this.props.organization.orgName}
                                            projectName={this.props.project.name}
                                            projectId={this.props.project._id}
                                            portalName={
                                                this.props.portal.portalName
                                            }
                                            portalId={this.props.portal._id}
                                        />
                                    </TabStripTab>
                                */}
                            </TabStrip>
                        </div>
                    </Content>
                )}
            </PageContainer>
        );
    }

    goToPortal = (e) => {
        if (this.props.isAccessedFromWorkspace) {
            this.props.mutators.setSelectedPortal(null);
        } else {
            this.setState({
                redirectToPortal: true,
            });
        }
    };

    handleSelect = (e) => {
        this.setState({ selected: e.selected }, () => {
            this.setState({ redirect: !this.props.isAccessedFromWorkspace });
        });
    };
}

export default withTranslation([
    "portal/portal_detail",
], {
    useSuspense: false,
})(PortalDetail);
